import { CSpinner } from "@coreui/react";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  apiCall,
  API_BASE_URL,
  PAYMNET_CANCEL_URL,
  PG_BASE_URL_PAYMENT,
  PG_WT_CLIENT_CODE,
} from "src/_apiConfig/apiCall";

export default function SubmitPayment() {
  const formRef = useRef(null);
  const [checksum, setchecksum] = useState("");
  const [pgpath, setpgpath] = useState("");
  const { id, amount, lotpaymentid } = useParams();

  const encrypted = window.btoa(id);

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  useEffect(() => {
    setpgpath(`${PG_BASE_URL_PAYMENT}/ws/payment`);
    console.log("pgpath - 3" + pgpath);
    const getDetails = async () => {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      header.append("Accept", "application/json");
      console.log("ID:" + id);
      console.log("lotpaymentid:" + lotpaymentid);
      const response = await apiCall(
        `LotDetails/initTransForLot?lotid=${id}&amount=${amount}&lotpaymentid=${lotpaymentid}`,
        "GET",
        header,
        null
      );
      const applicableTxnId = await response.json();
      if (response.status === 200 && applicableTxnId.length > 0) {
        var sessionID = makeid(35);
        const responseData = await apiCall(
          // `LotDetails/getTransParams?txnId=${txtID}&sessionId=${sessionID}&amount=${jsonobj[0].amount}&returnUrl=http://202.131.108.246:5000/api/PaymentResponse&cancelUrl=http://202.131.108.246:5000/api/PaymentResponse`,
          `LotDetails/getTransParams?txnId=${applicableTxnId}&sessionId=${sessionID}&lotid=${id}&amount=${amount}&lotpaymentid=${lotpaymentid}&returnUrl=${API_BASE_URL}PaymentResponse&cancelUrl=${PAYMNET_CANCEL_URL}?value=${encrypted}`,
          "GET",
          header,
          null
        );
        const jsonobjData = await responseData.json();
        console.log(jsonobjData);
        if (responseData.status === 200) {
          setchecksum(jsonobjData);
          formRef.current.submit();
        }
      } else {
        // TODO handle server error if payment cant proceed
      }
    };
    getDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotpaymentid, id]);

  return (
    <>
      {id ? (
        <form
          method="post"
          ref={formRef}
          action={pgpath}
          //action="https://demo.b2biz.co.in/ws/payment"
        >
          {/* <input type="hidden" name="walletClientCode" value="WT-1304" /> */}
          <input
            type="hidden"
            name="walletClientCode"
            value={PG_WT_CLIENT_CODE}
          />
          <input type="hidden" name="walletRequestMessage" value={checksum} />
        </form>
      ) : (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      )}
    </>
  );
}
